import React from 'react'
import Login from '../components/Login'
import Navbar from "../components/Navbar.jsx";

function LoginPage() {
  return (
    <div>
         <Navbar />
         <Login/>
      
    </div>
  )
}

export default LoginPage
